module.exports = __webpack_public_path__ + "media/images/icono_link-5574c96d681ae6b08e0f5b74aa4e8cd4.svg";